import React from 'react';
import { FaEnvelopeOpenText } from 'react-icons/fa';

const ContactUsTab = () => {
  return (
    <div className="p-6">
      <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center">
        <FaEnvelopeOpenText className="mr-2 text-blue-600" />
        Contact Us
      </h3>
      <div className="border rounded shadow-md overflow-hidden" style={{ height: '80vh' }}>
        <iframe
          src="https://yaqeentech.com/contact/"
          title="Yaqeen Contact"
          width="100%"
          height="100%"
          style={{ border: 'none' }}
        />
      </div>
    </div>
  );
};

export default ContactUsTab;

